export default {
  upcoming_meetings: '/session/api/get-upcoming-meetings',
  past_meetings: '/session/api/get-past-meetings',
  meeting_permissions: '/session/index/meeting-permissions',
};
